import(/* webpackMode: "eager" */ "/app/webapp/app/error.tsx");
